// Item Img
import img1 from "../../../assets/img/tab-img/TurkeyPackage.jpeg";
import img2 from "../../../assets/img/tab-img/Doha.jpeg";
import img3 from "../../../assets/img/tab-img/uzbekistanpackage.jpeg";
import img4 from "../../../assets/img/tab-img/bakuuu.png";
import img5 from "../../../assets/img/tab-img/maldives.jpg";
import img6 from "../../../assets/img/tab-img/thailland.jpg";
import img7 from "../../../assets/img/tab-img/hotel7.png";
import img8 from "../../../assets/img/tab-img/hotel8.png";
import umrah1 from "../../../assets/img/tab-img/umrah1.jpg";
import umrah2 from "../../../assets/img/tab-img/umrah2.jpg";
import umrah3 from "../../../assets/img/tab-img/umrah3.jpg";
import umrah4 from "../../../assets/img/tab-img/umrah4.jpg";
import hajj1 from "../../../assets/img/tab-img/hajj1.jpeg";
import hajj2 from "../../../assets/img/tab-img/hajj2.jpeg";
import hajj3 from "../../../assets/img/tab-img/hajj3.jpeg";
//Item Details Big Img
import BigImg from "../../../assets/img/tour/big-img.png";
import travelconsultingsmalll from "../../../assets/img/common/travelconsultingsmalll.png";
import corporatetravelsmalll from "../../../assets/img/common/corporatetravelsmalll.png";
import relegioustravelsmalll from "../../../assets/img/common/relegioustravelsmalll.png";

export const ExploreData = [
  {
    id: 1,
    img: img1,
    bigImg: BigImg,
    location: "Turkey",
    heading: "Turkey",
    reviewRating: "Valid till 30th May 2025",
    price: "$99.00",
    discount: true,
    discountPrice: "50%",
    url: "/leisure/turkey",
  },
  {
    id: 2,
    img: img2,
    location: "Baku",
    heading: "Doha with Baku",
    reviewRating: "Valid till 30th May 2025",
    price: "$69.00",
    url: "/leisure/doha",
    discount: false,
  },
  {
    id: 3,
    img: img3,
    location: "Uzbekistan",
    heading: "Uzbekistan",
    reviewRating: "Valid till 30th May 2025",
    price: "$79.00",
    url: "/leisure/uzbekistan",
    discount: false,
  },


  {
    id: 4,
    img: img4,
    location: "Baku",
    heading: "Baku",
    reviewRating: "Explore Our Packages",
    // reviewCount: "(1214 reviewes)",
    price: "$99.00",
    discount: true,
    url: "",
    discountPrice: "20%",
  },
  {
    id: 5,
    img: img5,
    location: "Maldives ",
    heading: "Visit Maldives with Us ",
    reviewRating: "Explore Our Packages",
    // reviewCount: "(114 reviewes)",
    price: "$49.00",
    url: "",
    discount: false,
  },
  {
    id: 6,
    img: img6,
    location: "Thailand",
    heading: "Visit Thailand with Us",
    reviewRating: "Explore Our Packages",
    // reviewCount: "(1214 reviewes)",
    price: "$99.00",
    url: "",
    discount: false,
  },
  {
    id: 7,
    img: img7,
    location: "Long island",
    heading: "Long Island",
    reviewRating: "Explore Our Packages",
    // reviewCount: "(1214 reviewes)",
    price: "$89.00",
    url: "",
    discount: false,
  },
  {
    id: 8,
    img: img8,
    location: "Philippine",
    heading: "Manila international resort",
    reviewRating: "Explore Our Packages",
    // reviewCount: "(1214 reviewes)",
    url: "",
    price: "$99.00",
    discount: false,
  },
  {
    id: 9,
    img: travelconsultingsmalll,
    location: "Philippine",
    heading: "Manila international resort",
    reviewRating: "Explore Our Packages",
    // reviewCount: "(1214 reviewes)",
    url: "",
    price: "$99.00",
    discount: false,
  },
  {
    id: 10,
    img: travelconsultingsmalll,
    location: "Philippine",
    heading: "Manila international resort",
    reviewRating: "Explore Our Packages",
    // reviewCount: "(1214 reviewes)",
    price: "$99.00",
    url: "",
    discount: false,
  },
  {
    id: 11,
    img: hajj1,
    location: "",
    heading: "Hajj Pre-Registration ",
    reviewRating: " for Hajj 2026",
    url: "",
    // reviewCount: "(1214 reviewes)",
    price: "$99.00",
    discount: false,
  },
  {
    id: 12,
    img: hajj2,
    location: "",
    heading: "Pre-Registration",
    reviewRating: " for Hajj 2026",
    url: "",
    // reviewCount: "(1214 reviewes)",
    price: "$99.00",
    discount: false,
  },
  {
    id: 13,
    img: hajj3,
    location: "",
    heading: "Pre-Registration",
    reviewRating: " for Hajj 2026",
    url: "",
    // reviewCount: "(1214 reviewes)",
    price: "$99.00",
    discount: false,
  },
  // {
  //   id: 14,
  //   img: umrah4,
  //   location: "Medina Before Hajj",
  //   heading: "Package-4 (14/15 Days)",
  //   reviewRating: "Medina Before Hajj",
  //   url: "/hajj/package-4",
  //   // reviewCount: "(1214 reviewes)",
  //   price: "$99.00",
  //   url: "",
  //   discount: false,
  // },
];

export const UmrahData = [
  {
    id: 21,
    img: umrah1,
    location: "Makkah",
    heading: "Umrah Package 1",
    reviewRating: "Valid for 2025",
    url: "/umrah/package-1",
    price: "$59.00",
    discount: false,
  },
  {
    id: 22,
    img: umrah2,
    location: "Madinah",
    heading: "Umrah Package 2",
    reviewRating: "Valid for 2025",
    url: "/umrah/package-2",
    price: "$69.00",
    discount: false,
  },
  {
    id: 23,
    img: umrah3,
    location: "Makkah & Madinah",
    heading: "Umrah Package 3",
    reviewRating: "Valid for 2025",
    url: "/umrah/package-3",
    price: "$79.00",
    discount: false,
  },
  {
    id: 24,
    img: umrah4,
    location: "Makkah",
    heading: "Umrah Package 4",
    reviewRating: "Valid for 2025",
    url: "/umrah/package-4",
    price: "$89.00",
    discount: false,
  },
];
